var _this = this;

import { getWorkout } from '../generated';
export var workoutDetailsWithMuscleGroupScore = function workoutDetailsWithMuscleGroupScore() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return getWorkout.apply(_this, args);
};